import { updateHeaderWidthToSlide } from '@/modules/actions/updateHeaderWidthAction';
import { getSwiperInstance } from '@/helpers/swiperInstance';
import { applySlideScaling } from "@/modules/actions/slideScaleAction";
import { activeVideoPlay } from "@/modules/actions/videoControls";
import { setupAutoPlayNextAction } from '@/modules/actions/desktop/setupAutoPlayNextAction';
import { checkVolumeButtonState } from "@/helpers/volumeControl";
import { animateCurrentProgressBar } from "@/modules/actions/headerLineDuration";
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

export const slideClickNavigateAction = () => {
  // PC時のみクリック移動を有効化
  if (window.storeeelItems.isMobile) return;
  const swiper = getSwiperInstance();
  const allSlides = document.querySelectorAll('.storeeel-swiper-group-wrapper  .swiper-slide');
  allSlides.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      // アクティブスライドをタップしたときは進捗リセットを防止
      if (swiper.activeIndex === index) return;
      if (swiper && typeof swiper.slideTo === 'function') {
        swiper.slideTo(index);
        window.moviePosition = index;
        applySlideScaling();
        updateHeaderWidthToSlide();

        const banners = document.querySelectorAll('.storeeel-movie-select_banner');
        banners.forEach((b, i) => b.style.padding = i === index ? '2px' : '');

        // スライドの動画再生
        activeVideoPlay();
        // 音量ボタンの状態に応じて動画のミュート変更
        checkVolumeButtonState();
        // 動画終了後の次の動画を再生
        setupAutoPlayNextAction();

        // スライドクリック後すぐに進捗バーリセット＆アニメーション
        const video = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper video');
        const image = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper img');
        let duration = 0;
        if (video) {
          if (video.readyState >= 1) {
            duration = video.duration;
          } else {
            video.addEventListener('loadedmetadata', () => {
              duration = video.duration;
            }, { once: true });
          }
        } else if (image) {
          duration = 5;
        }
        if (window.storeeelItems.frame === "circle") {
          animateCurrentProgressBar(duration, index);
        } else {
          animateCurrentProgressBar(duration, 0);
        }

        // 計測とローカルストレージ保存
        let mediaName;
        let mediaId;
        let groupId;
        if (video) {
          mediaName = video.getAttribute('media-name');
          mediaId = video.getAttribute('media-id');
        } else if (image) {
          mediaName = image.getAttribute('media-name');
          mediaId = image.getAttribute('media-id');
        }
        if (window.storeeelItems.frame === "circle") {
          groupId = window.iconId;
        } else {
          groupId = null;
        }
        trackStoreeelEvent('storeeel_media_asset_view', {
          'storeeel_name':  mediaName,
          'group_id':       groupId,
          'media_id':       mediaId,
          'campaign_id':    window.storeeelItems.id,
        });
        localStorageRepositories.get("mediaView").set(
          mediaId,
          window.storeeelItems.id
        );
      }
    });
  });
};
